import { resolveBuildRunNumber } from '@/features/builds/utils/buildRunNumber';
import { resolvePipelineRunDisplayStatus } from '@/features/pipelines/hooks/pipelineStatusScope';
import { resolvePipelineSlug } from '@/features/pipelines/utils/pipelineSlug';
import type { SummaryTooltipItem } from '@/ui/composites/table/tableUtils';
import type { PipelineListItemDto } from '@flowqa/shared';

export const mapPipelineRunSummaryItems = (row: PipelineListItemDto): SummaryTooltipItem[] => {
  const total =
    typeof row.buildTotal === 'number' && Number.isFinite(row.buildTotal)
      ? Math.max(row.buildTotal, 0)
      : null;
  const runs = total === null ? (row.runSummaries ?? []) : (row.runSummaries ?? []).slice(0, total);

  return runs.map((run) => {
    const runNumber = resolveBuildRunNumber(run.buildKey ?? null);
    const pipelineSlug = resolvePipelineSlug(row);

    return {
      key: run.id,
      detailLabel: row.name,
      executionLabel: runNumber === null ? null : `#${runNumber}`,
      href: `/pipelines/${pipelineSlug}`,
      executionHref: runNumber === null ? null : `/pipelines/${pipelineSlug}/runs/${runNumber}`,
      runNumber,
      status: resolvePipelineRunDisplayStatus(run),
      timestamp: run.timestamp,
    };
  });
};
